import * as clubApi from "shadow-client/endpoints/clubApi";
import * as fileApi from "shadow-client/endpoints/fileApi";
import * as productApi from "shadow-client/endpoints/productApi";
import { BEHAVIORS } from "shadow-client/endpoints/productApi/constants";
import { compose, lifecycle, withHandlers, withProps, withState } from "recompose";
import { connect } from "react-redux";
import { decodeParam } from "react-router-utils";
import { getOffer, getProduct, getSpecificProductBehavior } from "shadow-client/redux/selectors";
import { withTranslator } from "app/decorators";
import Immutable from "immutable";
import ProductPage from "./ProductPage";
import _addOfferToCart from "app/redux/actions/addOfferToCart";
import flattenDeep from "lodash/flattenDeep";

const mapStateToProps = (state, { productId, productBehaviorIds, offerId }) => ({
  product: getProduct(state, productId),
  productBehavior: getSpecificProductBehavior(state, productBehaviorIds, BEHAVIORS.COUNTER_LINE),
  offer: getOffer(state, offerId)
});

function componentWillMount() {
  const {
    setIsLoading,
    productId,
    fetchProduct,
    fetchOfferList,
    clubId,
    fetchProductBehaviorList,
    setProductBehaviorIds,
    setOfferId,
    fetchClub,
    fetchFile
  } = this.props;

  setIsLoading(true);

  Promise.all([
    fetchProduct(productId),
    fetchOfferList({
      params: {
        context: { club: clubId, channel: "web", date: new Date().toISOString() },
        product: productId
      }
    }),
    fetchProductBehaviorList({ params: { product: productId } })
  ])
    .then(([productResponse, offersResponse, productBehaviorListResponse]) => {
      const productBehaviors = productBehaviorListResponse["hydra:member"];
      setOfferId(offersResponse["hydra:member"].first().get("@id"));
      setProductBehaviorIds(productBehaviors.map(entity => entity.get("@id")));

      let filePromise = Promise.resolve();
      if (productResponse.getIn(["publicMetadata", "imagePath"])) {
        filePromise = fetchFile(productResponse.getIn(["publicMetadata", "imagePath"]), {
          headers: {
            Accept: "text/base64",
            "X-Accept-Encoding": "base64"
          }
        }).catch(error => {});
      }

      const clubsIncludedPromiseList = Immutable.fromJS(
        flattenDeep([
          filePromise,
          productBehaviors
            .map(productBehavior => {
              const productBehaviorClubsIncluded = productBehavior.getIn(["configuration", "clubsIncluded"]);
              return productBehaviorClubsIncluded
                ? productBehaviorClubsIncluded.map(clubId => fetchClub(clubId))
                : productBehaviorClubsIncluded;
            })
            .toJS()
        ])
      );
      return Promise.all(clubsIncludedPromiseList);
    })
    .then(() => {
      setIsLoading(false);
    });
}

const onAddToCart = props => () => {
  const { clubId, setIsPrepareCart, addOfferToCart, setIsOpen, product, offer, productBehavior } = props;
  setIsPrepareCart(true);
  addOfferToCart(clubId, product, offer, productBehavior).then(
    () => {
      setIsPrepareCart(false);
      setIsOpen(true);
    },
    () => {
      alert("Un problème est survenu.");
    }
  );
};

const onClose = ({ setIsOpen }) => () => {
  setIsOpen(false);
};

export default compose(
  withProps(({ match }) => ({
    productId: decodeParam(match.params.productId),
    clubId: decodeParam(match.params.clubId)
  })),
  connect(null, {
    fetchClub: clubApi.fetchClub,
    fetchProduct: productApi.fetchProduct,
    fetchProductBehaviorList: productApi.fetchProductBehaviorList,
    fetchOfferList: productApi.fetchOfferList,
    fetchFile: fileApi.fetchFile,
    addOfferToCart: _addOfferToCart
  }),
  withState("isLoading", "setIsLoading", true),
  withState("isPrepareCart", "setIsPrepareCart", false),
  withState("isOpen", "setIsOpen", false),
  withState("productBehaviorIds", "setProductBehaviorIds"),
  withState("offerId", "setOfferId"),
  connect(mapStateToProps),
  withHandlers({ onAddToCart, onClose }),
  lifecycle({ componentWillMount }),
  withTranslator
)(ProductPage);



// WEBPACK FOOTER //
// ./src/app/components/ProductPage/ProductPageContainer.js